import { gql } from "@apollo/client";

export const GET_TOTAL_COSTS_BY_SERVICE = gql`
  query GetTotalCostsByService($year: Int!, $month: Int!) {
    getTotalCostsByService(year: $year, month: $month) {
      serviceName
      totalCost
    }
  }
`;

export const GET_TOTAL_COSTS_BY_METER = gql`
  query GetTotalCostsByMeter($year: Int!, $month: Int!) {
    getTotalCostsByMeter(year: $year, month: $month) {
      meterName
      totalCost
    }
  }
`;

export const GET_SHARED_COSTS_BY_SERVICE = gql`
  query GetSharedCostsByService($year: Int!, $month: Int!) {
    getSharedCostsByService(year: $year, month: $month) {
      year
      month
      sharedCostsByService {
        serviceName
        totalCost
      }
    }
  }
`;

export const GET_COSTS_BY_SERVICE_NAME = gql`
  query GetCostsByServiceName(
    $startDate: String!
    $endDate: String!
    $serviceName: String!
  ) {
    getCostsByServiceName(
      startDate: $startDate
      endDate: $endDate
      serviceName: $serviceName
    ) {
      serviceNames
      months
      services {
        serviceName
        costs
      }
    }
  }
`;
